import React from 'react';
import styled, { css } from 'styled-components';
import { ThisAccount } from '../../../redux/Account/account.selectors';
import { SmartContainer } from '../../../styles/Containers';
import { StyledB, StyledP } from '../../../styles/StyledHTML';
import { Theme } from '../../../styles/Theme';
import { dayRemainingOnFreeTrial } from '../../../services/Utils';
import { StyledButton } from '../../../styles/matieralui/Button';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';

const StyledDarkened = styled(SmartContainer)`
  
    /* border-radius: ${Theme.radius}; */
    /* background-color: rgba(0,0,0,0.05); */
    border-radius: 0px;
    border-bottom: ${Theme.borderWidth} solid currentColor;
    background-color: ${Theme.colors.tertiary};
    color: ${Theme.colors.tertiaryText};
    padding: 1em;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${props => (props.days <= 3) ? css`background-color:${Theme.colors.error}; color: white;` : ''}
    @media(max-width: 768px) {
        display: block;
        text-align: center;
        > * {
            margin-bottom: 1em;
        }
    }
`

export const TrialAlert = () => {
    const account = ThisAccount();
    const daysLeft = dayRemainingOnFreeTrial(account);
    const unit = (daysLeft === 1) ? 'Day' : 'Days';
    const dispatch = useDispatch();

    const handleClick = () => dispatch(push('/billing'))

    let message = `Your free trial ends in ${daysLeft} ${unit}!`
    if (daysLeft <= 3) message = `${daysLeft} ${unit} remaining, upgrade to keep your files safe.`;

    return (
        <StyledDarkened days={daysLeft}>
            <SmartContainer>
                <StyledP><StyledB>{message}</StyledB></StyledP>
            </SmartContainer>
            <StyledButton variant='contained' color='base' onClick={handleClick}>Upgrade Now</StyledButton>
        </StyledDarkened>
    )
}